import { DiseaseSpecificityIndex } from '../../AboutHelpers.tsx';
import { FormulaAccordion } from './components/FormulaAccordion';
import { MetricRangeVisual } from './components/MetricRangeVisual';

const DSI_PINS = [
  {
    value: 0.23,
    label: 'TNF',
    sublabel: 'Associated with >3,500 diseases — low specificity',
  },
  {
    value: 1.0,
    label: 'MOB3A',
    sublabel: 'Associated with 1 disease — high specificity',
  },
];

function AboutMetricsSpecificity(): JSX.Element {
  return (
    <div id="specificity">
      <h3>Disease Specificity Index</h3>
      <p>
        The Disease Specificity Index (DSI) reflects whether a gene (or variant) is associated to several or
        fewer diseases. A low DSI indicates broad association (many diseases), while a high DSI indicates
        narrow association (few diseases). DSI ranges from 0.23 to 1.
      </p>
      <MetricRangeVisual
        min={0.23}
        max={1}
        pins={DSI_PINS}
        lowLabel="Low specificity (many diseases)"
        highLabel="High specificity (few diseases)"
        color="#0a104f"
      />
      <p className="text-sm text-gray-500 mt-1">
        If the DSI is empty, the gene/variant is associated only to phenotypes.
      </p>
      <FormulaAccordion label="View formula">
        <span>{DiseaseSpecificityIndex()}</span>
        <div className="mt-3 text-sm text-gray-600">
          <dt className="font-medium">where:</dt>
          <ul className="mt-1 space-y-1">
            <li>
              N<sub>d</sub> — number of diseases associated to the gene/variant
            </li>
            <li>
              N<sub>T</sub> — total number of diseases in DISGENET
            </li>
          </ul>
        </div>
      </FormulaAccordion>
    </div>
  );
}

export default AboutMetricsSpecificity;
